import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_admin/results_/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/results/$id/table', params: { id: params.id } });
  },
});
